import { Typography } from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import SignUp from "../components/SignUp";

import "./Account.css";

function Account(props) {
  return (
    <>
      <Typography variant="h2" sx={{ m: 1 }}>
        Account
      </Typography>

      {/* <Typography variant="subtitle1" sx={{ m: 1 }}>
        Sign up for an iO Energy Customer Portal Account
      </Typography> */}

      <Box sx={{ my: 1, display: "block" }}>
        <SignUp
          personalState={props.personalState}
          activeStepState={props.activeStepState}
          cafState={props.cafState.cafState}
          setCafState={props.cafState.setCafState}
        />
      </Box>
    </>
  );
}

export default Account;
